import { Paper } from '@mui/material';
import React, { useState } from 'react';
import type { EntityName } from '../common/auth/Security';
import AttributeGroupPreviewSection from './AttributeGroupPreviewSection';
import { Attribute } from './attributes';

export interface AttributeGroupProps {
    id: string;
    group: string;
    attributes: Attribute[];
    enableEdit?: boolean;
    onEdit?: (group) => void;
    enableDelete?: boolean;
    onDelete?: (id: string) => void;
    isHover?: boolean;
    isVerticalPreview?: boolean;
    onClickAttribute?: (field: Attribute) => void;
    isSelected?: (field: Attribute) => boolean;
    isInModal?: boolean;
    disableFlexGrow?: boolean;
    onToggleGroupSelection?: (attributes: Attribute[], selectAll: boolean) => void;
    entityName?: EntityName;
}

export default function AttributeGroupPreview(props: AttributeGroupProps) {
    const { group } = props;
    const [isHover, setIsHover] = useState(false);

    return (
        <Paper
            key={group}
            elevation={2}
            sx={{
                width: '100%',
                display: 'flex',
                gap: 2,
                p: 3,
                position: 'relative',
                flexDirection: 'column'
            }}
            onMouseEnter={() => setIsHover(true)}
            onMouseLeave={() => setIsHover(false)}
        >
            <AttributeGroupPreviewSection isHover={isHover} {...props} />
        </Paper>
    );
}
